import axios from "axios";
import { toastr } from "react-redux-toastr";
//import { closeModal, openModal } from "./modalAction";

import {
  // appPARAMETER types
  FETCH_PROJECTNAMERESIS_DWK,
  FETCH_PROJECTNAMECOMS_DWK,
  FETCH_LOCALITYS_DWK,
  
} from "./types";

//fetch all ProjectNameResis Dwarka
export const fetchProjectNameResis = () => async (dispatch) => {
  try {
    const res = await axios.post(`/api/dwk/ProjectNameResiList`);

    dispatch({ type: FETCH_PROJECTNAMERESIS_DWK, payload: res.data });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
// create ProjectNameResi
export const createProjectNameResi = (values) => async () => {
  try {
    const res = await axios.post("/api/dwk/ProjectNameResiCreate", values);
    if (res.data.msg === "errorAlready") {
      toastr.error("Residential Project Name Already Exist Use Another");
    }

    if (res.data.msg === "success") {
      toastr.success("Residential Project Name Created Successfully");
    }
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
//fetch all ProjectNameComs Dwarka
export const fetchProjectNameComs = () => async (dispatch) => {
  try {
    const res = await axios.post(`/api/dwk/ProjectNameComList`);

    dispatch({ type: FETCH_PROJECTNAMECOMS_DWK, payload: res.data });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
// create ProjectNameCom
export const createProjectNameCom = (values) => async () => {
  try {
    const res = await axios.post("/api/dwk/ProjectNameComCreate", values);
    if (res.data.msg === "errorAlready") {
      toastr.error("Commercial Project Name Already Exist Use Another");
    }

    if (res.data.msg === "success") {
      toastr.success("Commercial Project Name Created Successfully");
    }
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};

//fetch all Locality Dwarka
export const fetchLocalitys = () => async (dispatch) => {
  try {
    const res = await axios.post(`/api/dwk/LocalityList`);

    dispatch({ type: FETCH_LOCALITYS_DWK, payload: res.data });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};

// create Locality
export const createLocality = (values) => async () => {
  try {
    const res = await axios.post("/api/dwk/LocalityCreate", values);
    if (res.data.msg === "errorAlready") {
      toastr.error("Locality Name Already Exist Use Another");
    }

    if (res.data.msg === "success") {
      toastr.success("Locality Created Successfully");
    }
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};

// Action Dwarka Expressway

//fetch all ProjectNameResis Dwarka Expressway
export const fetchProjectNameResisExp = () => async (dispatch) => {
  try {
    const res = await axios.post(`/api/dwk/ProjectNameResiListExp`);

    dispatch({ type: FETCH_PROJECTNAMERESIS_DWKEXP, payload: res.data });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};

//fetch all ProjectNameComs Dwarka Expressway
export const fetchProjectNameComsExp = () => async (dispatch) => {
  try {
    const res = await axios.post(`/api/dwk/ProjectNameComListExp`);

    dispatch({ type: FETCH_PROJECTNAMECOMS_DWKEXP, payload: res.data });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};

//fetch all Locality Dwarka Expressway
export const fetchLocalitysExp = () => async (dispatch) => {
  try {
    const res = await axios.post(`/api/dwk/LocalityListExp`);

    dispatch({ type: FETCH_LOCALITYS_DWKEXP, payload: res.data });
  } catch (error) {
    toastr.error("Oops", "Something went wrong.Please Try Again");
  }
};
